import {
    initEmotionDetection,
    detectEmotions,
    generateFaceID,
    faceIdMap,
    findMatchingFaceIDLocationBased,
    filterFaceIdMap,
    landmarksWrapper,
    getDefaultOptions,
    clearFaceIdMap,
    soloInstance,
} from "./bioFeedback/emotions";
import {detectHRV} from "./bioFeedback/hrv";
import {initConfig, setConfigItem, getConfigItem} from "./config";

let initialized = false;
export const init = async (config, modelsDir) => {
    initConfig(config);
    await initEmotionDetection(modelsDir, config);
    initialized = true;
    return initialized
}

export const toggleMaskDetection = () => {
    let maskModelActive = getConfigItem('MASK_MODEL_ACTIVE');
    setConfigItem('MASK_MODEL_ACTIVE', !maskModelActive);
}

/**
 * Detects emotions from the input
 * @param input - HTMLImageElement, HTMLVideoElement, HTMLCanvasElement, ImageData or tf.Tensor3D
 * @param config - object with the following keys: {emotionsModelOptions, handsModelActive, isImage, showFaceLandmarks: {show, canvas}, sizeFilter}
 * @returns {Promise<*>}
 */
export const detect = async (input, config) => {
    if(!initialized){
        throw new Error('Emotion detection not initialized');
    }
    return await detectEmotions(input, config);
}

export {
    generateFaceID,
    faceIdMap,
    clearFaceIdMap,
    findMatchingFaceIDLocationBased,
    filterFaceIdMap,
    landmarksWrapper,
    getDefaultOptions,
    soloInstance,
    detectHRV
}
